import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function AdminHeader({ title }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 3, pt:{xs:5,md:0} }}>
      {/* Breadcrumb */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography
          variant="body2"
          color="text.secondary"

        >
          Administration
        </Typography>

        <Typography variant="body2" color="text.secondary">
          /
        </Typography>

        <Typography variant="body2" color="text.primary" fontWeight={500}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
}
